import { IRootState } from 'reducers';
import { createSelector } from 'reselect';

const proforientationVisitedSelector = createSelector(
  [(state: IRootState) => state.proforientation],
  (proforientation) => {
    return proforientation.content?.testing?.visited ?? null;
  },
);

export default proforientationVisitedSelector;
